import * as React from 'react';

type Types = {
  layout: KlarnaPlacementLayout;
  dataLocale: String;
  dataPurchaseAmountCents?: number;
};

declare global {
  namespace React.JSX {
    interface IntrinsicElements {
      'klarna-placement': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

export enum KlarnaPlacementLayout {
  CreditPromotionAutoSize,
  CreditPromotionSmall,
  CreditPromotionStandard,
  FooterPromotionAutoSize,
  SidePromotionAutoSize,
  TopStripPromotionAutoSize,
  CreditPromotionBadge,
  InfoPage,
  TopStripPromotionBadge,
  HompagePromotionTall,
  HomepagePromotionWide,
  HomepagePromotionBox,
}

function MapKlarnaPlacementLayouts(layout: KlarnaPlacementLayout) {
  return KlarnaPlacementLayout[layout]
    .replace(/([A-Z])/g, '-$1')
    .replace(/(^-)|(-$)/g, '')
    .toLowerCase();
}

export function KlarnaPlacement({ layout, dataLocale, dataPurchaseAmountCents }: Types) {
  return (
    <klarna-placement
      data-key={MapKlarnaPlacementLayouts(layout)}
      data-locale={dataLocale}
      data-purchase-amount={dataPurchaseAmountCents}
    />
  );
}
